import React, { useEffect, useState,useContext } from "react";
import { makeStyles } from "@mui/styles";
import {
  Chip,
  Container,
  Tooltip,
  Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Checkbox, FormControlLabel, Button, Grid, Dialog, DialogContent, Alert, AlertTitle, DialogActions, Typography, Backdrop, CircularProgress, List, DialogContentText, ListItem,Box
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { getPlanningOverview, getHistoryPlanningOverview, getReleaseDrafts, getSalesOfficesAndRoutes, pdfGenerate, releasePlanningMultiple, loadReportGenerate, getusersheduledList, releaseValidation, HistoryPdf, HistoryPdfRoute } from "../../utils/GetPlanning";

import { useLocalStorage } from "../../componentUtils/LocalStorage";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import { DraftLoadType, PlanningState, ReleaseData, ReleaseDraft } from './index';
import _ from "lodash";
import { CustomerData, LoadData, PredictionData} from "./Release";
import { letterSpacing } from "@mui/system";
import build_route_pdf from "src/utils/route-card-pdf";
import load_report_pdf from "src/utils/load_report_pdf";
import KeyboardArrowLeft from "@mui/icons-material/ArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/ArrowRight";
import { SoketContext, DisplayRoleContext } from "../../Context_api";

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  chart: {
    paddingTop: theme.spacing(3),
  },
  chipActual: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  activeCell: {
    color: '#e9232a'
  },
  dyActiveCell: {
    color: '#e623e9'
  },
  submit: {
    margin: theme.spacing(3),
  },
  release: {
    marginLeft:'192px'
  },
  releaseSubmit:{
    marginLeft: '200px',
  },
  arrowClass:{
   
    /*display:'flex',
    alignItems:'center',
    height:'100%',
    positon:'absoluete',
    */
  },
  mainArrowBox:{
    display: 'flex', 
    justifyContent:"space-between",
    width: '100%',
    position:"absolute",
     top:'50%',
     backgroundColor:'red',
  },
  ArrowLeft:{
    position:"relative",
    left:'-15px',
    //border:'100%',
    color:'white',
    fontSize:'59px !important',
    top:'45%'
    //backgroundColor:'red',
    
    // marginTop: theme.spacing(2),
  },
  ArrowLeftDisabled:{
    position:"absolute",
    left:'-28px',
  color: '#666666',
  },
  ArrowRightDisabled:{
    position:"absolute",
    right:'-28px',
  color: '#666666',
  },
  ArrowRight:{
    position:"relative",
    right:'15px',
    //border:'100%',
    color:'white',
    fontSize:'59px !important',
    top:'45%'
   // backgroundColor:'red',
    // marginTop: theme.spacing(2),
  },
  outerbox:{
    padding: '0 20px'
  },
  outerLeft:{
   position:'absolute',
   left:'0',
   width:'30px',
   height:'100%',
   background:'red',
   cursor:'pointer'
  },
  outerRight:{
    position:'absolute',
    right:'-23px',
    width:'30px',
    height:'100%',
    background:'red',
    cursor:'pointer'
  },
  row_height:{
height:'20px',
  }
}));

interface Inputs {
  setRoutesSelected:any
  data: PlanningState;
  isLoading: any;
  reloadHeaderStatus:any;
  autoSaveState:any;
  change:any;
  generateReleaseData:any;
  saveReleaseDraftSaveState:any
  addSessionCustomer:any
  session:any
  setRefresh:any
}

interface OverviewState {
  isLoaded: boolean;
  data: any;
}

interface pdfAlert{
  showRouteCardAlert:boolean;
  isDownloadRouteCardPdf:boolean;
  routeCardAlertMessage:any;
}

export default function Overview(props: Inputs) {
  const {broadcast,postmessage ,uuid,is_active,setActive}:any = useContext(SoketContext);
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);
  const [is_disabled, setIsdisabled] = useState(false);
  const classes = useStyles();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [state, setState] = useState<OverviewState>({
    isLoaded: false,
    data: []
  });
  const [backdropLoader, setBackdropLoader] = useState(false)
  const [releasebackdropLoader, setReleaseBackdropLoader] = useState(false)
  const [checkedRoutes, setCheckedRoutes] = useState <Set<string>>(new Set<string>());
  const [releaseRoutesAlert, setReleaseRoutesAlert] = useState<any>({});
  const [releaseLoadReportAlert, setReleaseLoadReportAlert] = useState<any>({});
  const[isReleaseLoadReport,setIsReleaseLoadReport]=useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [errorRouteMessage, setErrorRouteMessage] = useState({ "validate": true,
  "message":[]});

  const [releaseBtndisabled, setReleaseBtndisabled] = useState<boolean>(false);
  const [pdfData,setPdfData]=useState([]);
  // const [isRouteUnVerified,setIsRouteUnverified]=useState(false);
  // const [pdfUnverifiedRoutes,setPdfUnverifiedRoutes]=useState([]);
  const [isDownloadPdf,setIsDownloadPdf]=useState<boolean>(false);
  // const [pdfVerifiedRoute,setPdfVerifiedRoute]=useState([]);
  // const [pdfAlert,setPdfAlert]=useState<[{'isDownloadPdf':boolean,'pdfVerifiedRoutes':any,'pdfUnverifiedRoutes':any,'message':any}]>([{'isDownloadPdf':true,'pdfVerifiedRoutes':[],'pdfUnverifiedRoutes':[],'message':""}]);
  const [pdfAlert,setPdfAlert]=useState<pdfAlert>({showRouteCardAlert:false,isDownloadRouteCardPdf:true,routeCardAlertMessage:""});
   const [loadReportData, setLoadReportData] = useState<any>({});
   const [sheduledList, setSheduledList] = useState([]);
  const [stdate, setStdate] = React.useState<any>(new Date());
  const [previousWeekDis, setPreviousWeekDis] = useState<boolean>(true);
  const [previousData, setPreviousData] = useState<boolean>(true);
  const [futureWeekDis, setFutureWeekDis] = useState<boolean>(true);



  useEffect(() => {
  
    setIsdisabled(props.session.is_disable)
  }, [props.session, is_active])


  // useEffect(()=>{
  //   if(broadcast){
  //     if (broadcast.event === 'is_planning') {
  //       let b_params: any = broadcast?.message.split(';');
  //       if(salesOrg.toString()==b_params[0] &&
  //       props.data.selectedDeliveryPlant==b_params[1] && 
  //       props.data.selectedRoute==b_params[2] &&
  //       new Date(props.data.planningDate).toISOString()?.split("T")[0]==b_params[3] && 
  //        b_params[4]!=uuid){
  //         setIsdisabled(true)
  //         setActive(true)
  //       }
  //   }
  // }
  // },[broadcast])







  useEffect(() => {
    if(is_active){
      setIsdisabled(true)
      }
  props.setRoutesSelected('');
    if (state.isLoaded || !props.data.selectedDeliveryPlant) return;
    props.isLoading(true);
    const Pldate = new Date(new Date(props.data.planningDate).toISOString().split('T')[0])
    if(Pldate<new Date(new Date().toISOString().split('T')[0])){
      getHistoryPlanningOverview(salesOrg.toString(), props.data.selectedDeliveryPlant, new Date(Pldate),props.data.planMode).then(
        (v: any) => {
          setState({
            isLoaded: true,
            data: v
          });
          props.isLoading(false);
        });
    }else{
        getPlanningOverview(salesOrg.toString(), props.data.selectedDeliveryPlant, new Date(),props.data.planMode).then(
      (v: any) => {
        setState({
          isLoaded: true,
          data: v
        });
        props.isLoading(false);
        //props.reloadHeaderStatus();
      }).finally(()=>props.isLoading(false));
    }
    
  }, [state]);
  const PM_DYN = "DYNAMIC";
  const PM_STATIC = "STATIC";

  var dateRange = new Array<string>();
  if (state.data.dateFrom && state.data.dateTo) {
    const dateFrom:Date = new Date(Date.parse(state.data.dateFrom));
    const dateTo:Date = new Date(Date.parse(state.data.dateTo));
    var currDate = new Date(dateFrom);
    while (currDate.valueOf() < dateTo.valueOf()) {
      const dateStr = currDate.toISOString().split("T")[0];
      dateRange.push(dateStr);
      currDate.setDate(currDate.getDate() + 1);
    }
  }

  const title = "Planned Visits for " + props.data.selectedDeliveryPlant;

  const handleCheckChange = (route:any) => (event: any) => {
    //setChecked(event.target.checked);
   //('checked '+route+ ' as '+event.target.checked );
    let checkedRoutesSet = _.cloneDeep(checkedRoutes);
    if(!event.target.checked){     
      checkedRoutesSet.delete(route);
    }else{
      checkedRoutesSet.add(route);
    }
    setCheckedRoutes(checkedRoutesSet);
  };

  const handleAllCheckChange = (event: any) => {
    //setChecked(event.target.checked);
  //  console.log('checked all as '+event.target.checked );
    let checkedRoutesSet = _.cloneDeep(checkedRoutes);
    if(!event.target.checked){
      checkedRoutesSet=new Set<string>();
    }else{
      props.data.filteredRoutes.map((route: any) => {
        checkedRoutesSet.add(route.route);
      });
    }

    setCheckedRoutes(checkedRoutesSet);
  };

  // const releaseRoutesHandler = () => {
  //   const releaseData = props.generateReleaseData();
  //   console.log(JSON.stringify(releaseData));
  // }

  const releaseRoutesHandler = () => {
    let allRoutes =[...checkedRoutes.values()];
    //console.log("check for routes");
    // getusersheduledList(
    //   salesOrg.toString(),
    //   allRoutes,
    //   props.data.planningDate,
    //   props.data.selectedDeliveryPlant,
    //  ).then((res:any)=>{
    //   setSheduledList(res)

props.saveReleaseDraftSaveState()


    let routes =[...checkedRoutes.values()];
    let allowedRoutes:any=[]
    let isCurrentRouteSelected =false;
    if(checkedRoutes.has(props.autoSaveState.route)){
      isCurrentRouteSelected=true;
     routes= routes.filter(route => {return route !== props.autoSaveState.route});
    }

    //console.log(JSON.stringify(state));
    if(routes&&routes.length>0){
      //contains routes other than current route
    getReleaseDrafts(salesOrg,props.data.selectedDeliveryPlant,routes, props.autoSaveState.planningDateStr).then((v: any) => {
      let unverifiedRoutes:any[] = [];
      if(v?.unverifiedRoutes && v.unverifiedRoutes?.length > 0){
        unverifiedRoutes = v.unverifiedRoutes?.map((item:any) => item?.route_act)
      }
      if (v.savedDrafts && v.savedDrafts.length>0){
        //console.log(JSON.stringify(v));
        let savedDrafts:any[] =[];
        let allowedReleaseRoutes ='';
        v.savedDrafts.map((draftGroup:any,index:number) => {
          if(draftGroup&&draftGroup.length>0){
            
            let allowRoute=true;
            if(unverifiedRoutes&&unverifiedRoutes.includes(draftGroup[0].route)){
              allowRoute=false;
            }
            // if(index>=1){
            //   allowedReleaseRoutes=allowedReleaseRoutes;
            //   if(allowRoute){
            //   allowedRoutes.push(draftGroup[0].route)
            // }
            // }
            if(allowRoute){
              allowedReleaseRoutes=`${allowedReleaseRoutes}${allowedReleaseRoutes!=''?",":""}${draftGroup[0].route}`;
              allowedRoutes.push(draftGroup[0].route);
              savedDrafts.push(draftGroup);
            }
            
          }
        });
        
        if(isCurrentRouteSelected){

          if(props.data.scheduled>=1){
            setReleaseBtndisabled(false);
            if(allowedReleaseRoutes&&allowedReleaseRoutes!=''){
              allowedReleaseRoutes=allowedReleaseRoutes+','+props.autoSaveState.route;
            }else{
              allowedReleaseRoutes=''+props.autoSaveState.route;
            }
            allowedRoutes.push(props.autoSaveState.route);
          }
          else{
            allowedReleaseRoutes=allowedReleaseRoutes; //+','+props.autoSaveState.route;
            //allowedRoutes.push(props.autoSaveState.route);
          }

          
        }
        
        let removedRoutes=arr_diff(allowedRoutes,allRoutes);
        //let unverifiedRoutes:any[] = [];
        if(v?.unverifiedRoutes && v.unverifiedRoutes?.length > 0){
          //unverifiedRoutes = v.unverifiedRoutes?.map((item:any) => item?.route_act)
          let missingUnverifiedRoutes=unverifiedRoutes.filter(i => !removedRoutes.includes(i))
          removedRoutes = removedRoutes.concat(missingUnverifiedRoutes);//unverifiedRoutes.filter((item:any) => !removedRoutes.includes(item))
        }
        let removedRouteMsg=`For Delivery Plant: ${props?.data?.selectedDeliveryPlant}`;
        if(removedRoutes&&removedRoutes.length>0){
          const isPlural=removedRoutes&&removedRoutes.length>1;
          removedRouteMsg=''+`${isPlural?'Routes ':'Route '}` + removedRoutes.toString()+ ` ${isPlural?' are':' is'}`+' removed from submitting as '+` ${isPlural?' they are':'it is'}`+' either confirmed or not planned or not verified.'
        }
        let unverifiedRouteMsg=''
        if(unverifiedRoutes&&unverifiedRoutes?.length > 0){
          const isPlural=unverifiedRoutes&&unverifiedRoutes.length>1;
          unverifiedRouteMsg = ''+`${isPlural?'Routes ':'Route '}`+ unverifiedRoutes.toString() + ` ${isPlural?' are':' is'}`+' not verified. Please verify '+` ${isPlural?'those':'this'}`+' from planning board or proceed releasing excluding '+` ${isPlural?'these routes.':'this route.'}`;
        }
        const isPlural=allowedRoutes&&allowedRoutes.length>1;
        let msg=removedRouteMsg+ "\n" + unverifiedRouteMsg +" Do you wish to proceed?";
        // let removedRoutes=arr_diff(allRoutes,allowedRoutes);
        // console.log('difference',removedRoutes)
        if (allowedRoutes.length>0) {
          msg= `For Delivery Plant: ${props?.data?.selectedDeliveryPlant},` + " From the selected routes " +allowedReleaseRoutes+ ` ${isPlural?' are':' is'}`+" scheduled and available for release."+ 'Do you wish to proceed?';
          setReleaseBtndisabled(false);
        }else{
          setReleaseBtndisabled(true);
        }
        setReleaseRoutesAlert({ title: `Confirm Release Routes- Delivery Plant: ${props?.data?.selectedDeliveryPlant}`, msg: msg,actionData:{savedDrafts:savedDrafts,isCurrentRouteSelected:isCurrentRouteSelected}});
    
      }else{  
        // no draft saved routes
        if(isCurrentRouteSelected){
          if(props.data.scheduled>=1){
          allowedRoutes=[props.autoSaveState.route];}
          
          let removedRoutes=arr_diff(allowedRoutes,allRoutes);
        let unverifiedRoutes:any[] = [];
        if(v?.unverifiedRoutes && v.unverifiedRoutes?.length > 0){
          unverifiedRoutes = v.unverifiedRoutes?.map((item:any) => item?.route_act)
          let missingUnverifiedRoutes=unverifiedRoutes.filter(i => !removedRoutes.includes(i))
          removedRoutes = removedRoutes.concat(missingUnverifiedRoutes);
        }
        let removedRouteMesg=`For Delivery Plant: ${props?.data?.selectedDeliveryPlant}`;
        if(removedRoutes&&removedRoutes.length>0){
          const isPlural=removedRoutes&&removedRoutes.length>1;
          removedRouteMesg=''+`${isPlural?'Routes ':'Route '}`+removedRoutes.toString()+` ${isPlural?' are':' is'}`+' removed from submitting as '+` ${isPlural?' they are':'it is'}`+' either confirmed or not planned or not verified.'
        }
        let unverifiedRouteMesg=''
        if(unverifiedRoutes&&unverifiedRoutes?.length > 0){
          const isPlural=unverifiedRoutes&&unverifiedRoutes.length>1;
          unverifiedRouteMesg = ''+`${isPlural?'Routes ':'Route '}${unverifiedRoutes.toString()}` + ` ${isPlural?' are':' is'}`+' not verified. Please verify '+` ${isPlural?'those':'this'}`+' from planning board or proceed releasing excluding '+` ${isPlural?'these routes.':'this route.'}`;
        }
        let msg='';
          if(props.data.scheduled==0){
            setReleaseBtndisabled(true);
            if(removedRouteMesg!=''||unverifiedRouteMesg!=''){
              msg=""+removedRouteMesg+ "\n" + unverifiedRouteMesg +" No route is scheduled and available for release. Do you wish to proceed?";
            }else{
            msg= `For Delivery Plant: ${props?.data?.selectedDeliveryPlant}` + "No route is scheduled and available for release." ;//+removedRouteMsg+" Do you wish to proceed with these?";
            }
          }
          else{
            setReleaseBtndisabled(false);
            msg= `For Delivery Plant: ${props?.data?.selectedDeliveryPlant}`+ " From the selected routes " +props.autoSaveState.route+" is scheduled and available for release."+removedRouteMesg+ "\n" + unverifiedRouteMesg +" Do you wish to proceed?";
          } 
         //only current route allowed to submit
          setReleaseRoutesAlert({ title: `Confirm Release Routes- Delivery Plant: ${props?.data?.selectedDeliveryPlant}`, msg: msg,actionData:{savedDrafts:[],isCurrentRouteSelected:isCurrentRouteSelected}});
      
        }else{
          //no routes allowed to submit
          let unverifiedRoutes:any[] = [];
          if(v?.unverifiedRoutes && v.unverifiedRoutes?.length > 0){
            unverifiedRoutes = v.unverifiedRoutes?.map((item:any) => item?.route_act)
          }
          let unverifiedRouteMsg='';
          let msg=`For Delivery Plant: ${props?.data?.selectedDeliveryPlant},`;
          if(unverifiedRoutes&&unverifiedRoutes?.length > 0){
            const isPlural=unverifiedRoutes&&unverifiedRoutes.length>1;
            unverifiedRouteMsg = ''+`${isPlural?' Routes ':' Route '}`+ unverifiedRoutes.toString() + ` ${isPlural?' are':' is'}`+' not verified. Please verify '+` ${isPlural?'those':'this'}`+' from planning board or proceed releasing excluding '+` ${isPlural?'these routes.':'this route.'}`;
          }else{
            msg=msg+`No route is scheduled and available for release.` ;//+removedRouteMsg+" Do you wish to proceed with these?";
          }
          setReleaseBtndisabled(true);
          setReleaseRoutesAlert({ title: `Confirm Release Routes- Delivery Plant: ${props?.data?.selectedDeliveryPlant}`, msg: msg+"\n" + unverifiedRouteMsg ,actionData:{savedDrafts:[],isCurrentRouteSelected:isCurrentRouteSelected}});
        }

      }
    });
  }else{
    if(isCurrentRouteSelected){
      allowedRoutes=[props.autoSaveState.route];
      let removedRoutes=arr_diff(allowedRoutes,allRoutes);
      // console.log('difference',removedRoutes)
      let removedRouteMsg='';
        if(removedRoutes&&removedRoutes.length>0){
          const isPlural=removedRoutes&&removedRoutes.length>1;
          removedRouteMsg= ''+`${isPlural?' Routes ':' Route '}` +removedRoutes.toString()+` ${isPlural?' are':' is'}`+' removed from submitting as '+` ${isPlural?'they are':'it is'}`+' either confirmed or not planned or not verified.'
        }
        let msg=`For Delivery Plant: ${props?.data?.selectedDeliveryPlant}, `;
        if(props.data.scheduled==0){
          setReleaseBtndisabled(true);
          msg="No route is scheduled and available for release."; //+removedRouteMsg+" Do you wish to proceed with these?";
        }
        else{
          setReleaseBtndisabled(false);
          msg="From the selected routes " +props.autoSaveState.route+" is scheduled and available for release."+removedRouteMsg+" Do you wish to proceed?";
        }
      
      //only current route allowed to submit
      setReleaseRoutesAlert({ title:  `Confirm Release Routes- Delivery Plant: ${props?.data?.selectedDeliveryPlant}`, msg: msg,actionData:{savedDrafts:[],isCurrentRouteSelected:isCurrentRouteSelected}});
      
    }else{
      //no routes allowed to submit
      //TODO handle only unverified routes
    }
  }
  
//})
  };

  const downloadPdf=()=>{
    setPdfAlert({...pdfAlert,showRouteCardAlert:false});
    if(!isDownloadPdf){
      setIsDownloadPdf(true);
    build_route_pdf(pdfData, props.data.selectedDeliveryPlant)
    }
    setTimeout(()=>{setIsDownloadPdf(false)},2000);
  }

  const handlePdfGenerate = () => {
    setBackdropLoader(true);
    let allRoutes =[...checkedRoutes.values()];



    getusersheduledList(
      salesOrg.toString(),
      allRoutes,
      props.data.planningDate,
      props.data.selectedDeliveryPlant,
     ).then((res:any)=>{
      setSheduledList(res)
      let verifiedRoute=true;
      if(allRoutes.length>0){
       for (let index = 0; index < allRoutes.length; index++) {
         const element = allRoutes[index];
         if(state.data.data[props.autoSaveState.planningDateStr+';'+element]?.confirmed==0){
          verifiedRoute=false
         }
         
       }
   
      }

      let todayDate=new Date().toISOString().split("T")[0]; 
      if(props.autoSaveState.planningDateStr <todayDate){
        HistoryPdfRoute(salesOrg,props.autoSaveState.planningDateStr,props.data.selectedDeliveryPlant,allRoutes).then((v) => { 
          setBackdropLoader(false);
        });
       }else{
    pdfGenerate(salesOrg, allRoutes, props.autoSaveState.planningDateStr, props.data.selectedDeliveryPlant )
    .then((v) => {

       setBackdropLoader(false);
       if(v === 'No scheduled or confirmed customers on selected routes'){
         let message=('No scheduled or confirmed customers on selected routes. Select different route and try again');
        setPdfAlert({...pdfAlert,showRouteCardAlert:true,isDownloadRouteCardPdf:false,routeCardAlertMessage:message});
       }
      // /**when v.length === 1 means that only unverified routes are present*/
       else if(v.length===1){
        let pdfUnverifiedRoutes=v[0]['unverifiedRoutes'];
        let message=pdfUnverifiedRoutes.length>1?`Routes ${pdfUnverifiedRoutes.join(',')} are not verified. Please verify this from planning board.`:`Route ${pdfUnverifiedRoutes} is not verified. Please verify this from planning board.`;
        setPdfAlert({...pdfAlert,showRouteCardAlert:true,isDownloadRouteCardPdf:false,routeCardAlertMessage:message});
      }
      /**when v.length>1 means that unverified routes and pdf data both are present*/
      else if(v.length>1){
        const pdfData=v.slice(0,-1);
     
        const verifiedRoutes=pdfData.map((item:any)=>item.route);
        let verifiedRouteMessage=verifiedRoutes.length>1?` From the selected routes ${verifiedRoutes.join(',')} are eligible for download.`:` From the selected route ${verifiedRoutes} is elgible for download.`
        /**Checking whether unverified routes are present */
        if (v[v.length-1]['unverifiedRoutes'].length>0) {
          setPdfData(pdfData);
          const unverifiedRoutes=v[v.length-1]['unverifiedRoutes'];
          let unverifiedRoutesMessage=unverifiedRoutes.length>1?`Routes ${unverifiedRoutes.join(',')} are not verified. Please verify this from planning board.`:`Route ${unverifiedRoutes} is not verified. Please verify this from planning board.`;
          const message=`${verifiedRouteMessage} ${unverifiedRoutesMessage} or proceed download excluding this route. Do you wish to proceed.`
          setPdfAlert({...pdfAlert,showRouteCardAlert:true,isDownloadRouteCardPdf:true,routeCardAlertMessage:message});
        }else{
          if(v?.length > 0){
            setPdfData(pdfData);
            setPdfAlert({...pdfAlert,showRouteCardAlert:true,isDownloadRouteCardPdf:true,routeCardAlertMessage:verifiedRouteMessage+'Do you wish to proceed.'});
            // build_route_pdf(pdfData);
          }else{
            let message=('Error while downloading the pdf');
            setPdfAlert({...pdfAlert,showRouteCardAlert:true,isDownloadRouteCardPdf:false,routeCardAlertMessage:message});
          }
        }
       //}
      }
    })
    .catch((e) => {
      let message=('Failed to download the pdf, Please try again later');
      setPdfAlert({...pdfAlert,showRouteCardAlert:true,isDownloadRouteCardPdf:false,routeCardAlertMessage:message});
    }) }
    })
 
  }

  const handleLoadReportGenerate = () => {
    setBackdropLoader(true);
    let allRoutes = [...checkedRoutes.values()]
    let allowedRoutes:any=[]
    getusersheduledList(
      salesOrg.toString(),
      allRoutes,
      props.data.planningDate,
      props.data.selectedDeliveryPlant,
     ).then((res:any)=>{
      setSheduledList(res);
      let verifiedRoute=true;
      if(allRoutes.length>0){
       for (let index = 0; index < allRoutes.length; index++) {
         const element = allRoutes[index];
         if(state.data.data[props.autoSaveState.planningDateStr+';'+element]?.confirmed==0){
          verifiedRoute=false
         }
         
       }
   
      }
    loadReportGenerate(salesOrg, allRoutes, props.autoSaveState.planningDateStr, props.data.selectedDeliveryPlant, props.data.planMode)
    .then((v) => {
      setBackdropLoader(false);
      // if(v === 'No scheduled or confirmed customers on selected routes'){
      //   alert('No scheduled or confirmed customers on selected routes. Select different route and try again')
      // }
      // else{

    
        let unverifiedRoutes:any[] = [];
        if(v?.unverifiedRoutes && v.unverifiedRoutes?.length > 0){
          unverifiedRoutes = v.unverifiedRoutes?.map((item:any) => item?.route_act)
        }


        let allowedReleaseRoutes:any[] = [];
        if(v?.truckLoadResponse && v.truckLoadResponse?.length > 0){
          allowedReleaseRoutes = v.truckLoadResponse?.map((item:any) => item?.route)
        }
        //console.log("allowedReleaseRoutes",allowedReleaseRoutes);
     

        if(v?.unverifiedRoutes == 0 && v?.truckLoadResponse?.length > 0){

          // load_report_pdf(v?.truckLoadResponse)
          let allowedReleaseRoutesData = allowedReleaseRoutes?.join(',');
          setLoadReportData(v?.truckLoadResponse);
          let msg=` From the selected routes ${allowedReleaseRoutesData} ${allowedReleaseRoutesData.length>1?'are':'is'} eligble for download. Do you wish to proceed?`;
          setReleaseLoadReportAlert({ title: "Download Load report ", msg: msg,actionData:{} });
        }else if(v?.unverifiedRoutes?.length > 0 && v?.truckLoadResponse?.length > 0){

//           if(verifiedRoute){
        
//             if(v?.truckLoadResponse?.length > 0){
          
//                  load_report_pdf(v?.truckLoadResponse);
               
               
//              }
//            }

// else{
          let unVerifiedRoutes = unverifiedRoutes?.join(',');
          let allowedReleaseRoutesData = allowedReleaseRoutes?.join(',')
         // console.log("unVerifiedRoutes",unVerifiedRoutes);
          setLoadReportData(v?.truckLoadResponse)
          // let msg="From the selected routes " +allowedReleaseRoutes.toString()+" add text"+ unVerifiedRoutes.toString() +" not verified. Please verify from planning board";
          let msg="From the selected routes " + unVerifiedRoutes +" not verified, please verify before downloading. Proceed with download load reports for Routes "+ allowedReleaseRoutesData + "?";
          setReleaseLoadReportAlert({ title: "Download Load report ", msg: msg,actionData:{} });
          //}
        }else if(v?.unverifiedRoutes?.length > 0){
          let isCurrentRouteSelected =false;
          let unVerifiedRoutes = unverifiedRoutes?.join(','); 
          // let allowedReleaseRoutesData = allowedReleaseRoutes?.join(',')
          let msg=`From the selected routes ${unVerifiedRoutes} ${unverifiedRoutes.length>1?'are':'is'} not verified, please verify before downloading.`;
          setReleaseBtndisabled(true);
          setReleaseRoutesAlert({ title: "Download Load report ", msg: msg,actionData:{savedDrafts:[],isCurrentRouteSelected:isCurrentRouteSelected} });
        }
        else {
          let isCurrentRouteSelected =false;
          //  alert('Error while downloading the pdf')
          let msg="No eligible customers(scheduled/confirmed) on selected routes";
          setReleaseBtndisabled(true);
          setReleaseRoutesAlert({ title: "Download Load report ", msg: msg,actionData:{savedDrafts:[],isCurrentRouteSelected:isCurrentRouteSelected} });

        }
       
    })
    .catch((e) => {
      //alert('Failed to download the pdf, Please try again later');
      let message=('Failed to download the pdf, Please try again later');
      setPdfAlert({...pdfAlert,showRouteCardAlert:true,isDownloadRouteCardPdf:false,routeCardAlertMessage:message});
    })
    })
  }

  function arr_diff (a1:any, a2:any) {

    var a = [], diff = [];

    for (var i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
    }

    for (var i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
            delete a[a2[i]];
        } else {
            a[a2[i]] = true;
        }
    }

    for (var k in a) {
        diff.push(k);
    }

    return diff;
}

const releaseLoadReport = () =>{
  // setReleaseBtndisabled(true)
  // setReleaseBackdropLoader(true);
  if(!isReleaseLoadReport){
    setIsReleaseLoadReport(true);
  if(loadReportData){
    load_report_pdf(loadReportData);
    setReleaseLoadReportAlert({});
    }
  }
  setTimeout(()=>{
    setIsReleaseLoadReport(false);
  },2000);
 
}
  const releaseRoutesSubmit = () => {

   // postmessage(`${salesOrg.toString()};${props.data.selectedDeliveryPlant};${props.data.selectedRoute};${new Date(props.data.planningDate).toISOString()?.split("T")[0]};${uuid}`)
    setReleaseBtndisabled(true)
    setReleaseBackdropLoader(true);
    const savedDraftsList: ReleaseDraft[][] = releaseRoutesAlert.actionData.savedDrafts;
    
    const releaseDatas: ReleaseData[] = [];
    if (savedDraftsList && savedDraftsList.length > 0) {
      savedDraftsList.map((savedDrafts) => {
        // load data
        var loadList = new Array<LoadData>();
        var customerList = new Array<CustomerData>();
        const routeNumber = savedDrafts[0].route;

        function groupBy(list: any, keyGetter: any) {
          const map = new Map();
          list.forEach((item: any) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
              map.set(key, [item]);
            } else {
              collection.push(item);
            }
          });
          return map;
        }

        const grouped = groupBy(savedDrafts, (savedDraft: { draft_load_type: any }) => savedDraft.draft_load_type);

        const truckLoads: ReleaseDraft[] = grouped.get(DraftLoadType.TRUCKLOAD);
        const customerLoads: ReleaseDraft[] = grouped.get(DraftLoadType.CUSTOMERLOAD);
        if (truckLoads) {
          truckLoads.map((draftItem) => {
            const loadData: LoadData = {
              materialNum: draftItem.material_num,
              loadCS: draftItem.total_cs,
              convFactor: draftItem.conv_factor,
            };
            //loadList.push(loadData);
          });
        }

        if (customerLoads) {
          const customerGroupLoadDrafts = groupBy(
            customerLoads,
            (resultdata: { customer_num: any }) => resultdata.customer_num
          );
          customerGroupLoadDrafts.forEach((customerDraftItems: ReleaseDraft[], customer_num: string) => {
            if (customerDraftItems && customerDraftItems.length > 0) {
              const route = customerDraftItems[0].route;
              const equipmentNum = customerDraftItems[0].equipment_num;
              const deliveryType = customerDraftItems[0].delivery_type;
              var predictionList = new Array<PredictionData>();
              customerDraftItems.map((draftItem) => {
                const predictionData: PredictionData = {
                  materialNum: draftItem.material_num,
                  consignment: draftItem.consignment,
                  averageSales: draftItem.average_consumption,
                  totalEA: draftItem.refill_quantity,
                  convFactor: draftItem.conv_factor,
                };
                predictionList.push(predictionData);
              });

              const customerNotes:any = []
             
              const customerData: CustomerData = {
                route:route,
                customerNum: customer_num,
                equipmentNum:'' ,//equipmentNum,
                predictionList:[],
                deliveryType:'',// "" + deliveryType,
                customerNotes:[]
              };
             
                customerList.push(customerData);
              
              
            }
          });
        }

        const releaseData: ReleaseData = {
          plant: props.data.selectedDeliveryPlant,
          route: routeNumber,
          loadDate: props.data.planningDate,
          
          customerList:customerList,
          loadList:[],
        };

        releaseDatas.push(releaseData);
      });

    }

    if(releaseRoutesAlert.actionData.isCurrentRouteSelected){
    const releaseData = props.generateReleaseData();
   // console.log('debug123',releaseData);
    //releaseData.customerList=[];
    releaseData.loadList=[];
    releaseDatas.push(releaseData);
    }

    if(releaseDatas.length>0){
       let releaseDatass:any ={ selectedRoute:props.data.selectedRoute,
        routes:releaseDatas
       }
       releaseValidation(
        salesOrg.toString(),
        props.data.planningDate,
        props.data.selectedDeliveryPlant,
        releaseDatass
       ).then(res=>{
        if(res){
          props.addSessionCustomer(res.culist)
          setErrorRouteMessage({
            validate:res.validate,
            message:res.message
         })
        }
     

       if(res.validate==true){

   
    releasePlanningMultiple(salesOrg.toString(), releaseDatass, props.data.planMode,uuid).then((v: any) => {
      if (v) {

        if(v?.length>0){
          let responses=':'
          v?.forEach((responces:any,index:number) => {
            responses+=','+responces.customer

          })
         
          setErrorMessage(`Below provided Routes (${props.data.selectedRoute}) are found scheduled from another session, Please reload and verify data is correct before submit!:- ${responses}`);
          return
        }


        setReleaseBtndisabled(false);
        setReleaseBackdropLoader(false);
        if (v.status === "S") {
          let responses='';
          if (v?.responseStatus && v?.responseStatus?.length > 0) {
            v?.responseStatus.forEach((routeResponse:any,index:number) => {
              let statusMsg=routeResponse.status;
              if(statusMsg.charAt(0)==='S'){
                props.addSessionCustomer([])
                statusMsg = statusMsg.substring(0, 0) + 'Success ' + statusMsg.substring(0 + 1);
              }else if(statusMsg==='E'){
                statusMsg='Failed'; 
              }
              responses+='Route '+routeResponse.route+' : '+statusMsg;
              if((index+1)<v?.responseStatus?.length){
                responses+=', '
              }
            });
          }
          if(responses?.length > 0){
            setErrorMessage("Completed releasing routes. Please see the status of all releases. "+responses);
          }else {
            props.change();
          }
        } else if (v.status === "E") {
          setErrorMessage("Unknown error submitting routes");
          let responses='';
          if (v?.responseStatus && v?.responseStatus?.length > 0) {
            v?.responseStatus.forEach((routeResponse:any,index:number) => {
              let statusMsg=routeResponse.status;
              if(statusMsg.charAt(0)==='S'){
                statusMsg = statusMsg.substring(0, 0) + 'Success ' + statusMsg.substring(0 + 1);
              }else if(statusMsg==='E'){
                statusMsg='Failed'; 
              }
              responses+='Route '+routeResponse.route+' : '+statusMsg;
              if((index+1)<v?.responseStatus?.length){
                responses+=', '
              }
            });
          }
          if(responses?.length > 0){
            setErrorMessage("Completed releasing routes. Please see the status of all releases. "+responses);
          }else {
            console.error(errorMessage);
          }
        } else {
          setErrorMessage(v);
          console.warn(v);
        }
        setReleaseRoutesAlert({});
      }
    });
  }})
  }
  else{
    setErrorMessage("Unknown error submitting routes");
  }
    // console.log("Release Datas:: " + JSON.stringify(releaseDatas));


  };

  function subtract6Months(date:any) {
    date.setMonth(date.getMonth() - 6);
  
    return date;
  }

  const handleFutureRelease = () =>{
    props.isLoading(true);
    let checkedRoutesSet = _.cloneDeep(checkedRoutes);
    checkedRoutesSet=new Set<string>();
    setCheckedRoutes(checkedRoutesSet);
    setPreviousWeekDis(true);
   var currDate = new Date(state.data.dateTo);
   const curDate = new Date();
   const currentTime:any = curDate;
   currentTime.setDate(currentTime.getDate()+13);
   const startDate = new Date(Date.parse((state.data.dateFrom || "").toString()));
    var fromDate = new Date(startDate);
    fromDate.setDate(fromDate.getDate() - 8);
    if(currentTime<=currDate){
      setFutureWeekDis(false);
    }
    const Pldate = new Date(new Date(state.data.dateTo).toISOString().split('T')[0])
    if(Pldate<new Date(new Date().toISOString().split('T')[0])){
    setPreviousData(false);
    getHistoryPlanningOverview(salesOrg.toString(), props.data.selectedDeliveryPlant, currDate,props.data.planMode).then(
      (v: any) => {
        setState({
          isLoaded: true,
          data: v
        });
        props.isLoading(false);
      props.reloadHeaderStatus();
      }).finally(()=>props.isLoading(false));
   }else{
    setPreviousData(true);
    getPlanningOverview(salesOrg.toString(), props.data.selectedDeliveryPlant, currDate,props.data.planMode).then(
      (v: any) => {
        setState({
          isLoaded: true,
          data: v
        });
        props.isLoading(false);
      props.reloadHeaderStatus();
      }).finally(()=>props.isLoading(false));
   }
   
  };

  const handlePreviousRelease = () =>{
    props.isLoading(true);
    setFutureWeekDis(true);
    let checkedRoutesSet = _.cloneDeep(checkedRoutes);
    checkedRoutesSet=new Set<string>();
    setCheckedRoutes(checkedRoutesSet);
    const startDate = new Date(Date.parse((state.data.dateFrom || "").toString()));
    var fromDate = new Date(startDate);
    fromDate.setDate(fromDate.getDate() - 7);

    const Pldate = new Date(props.data.planningDate);    
    const prDate = subtract6Months(Pldate);
    if(prDate>=fromDate){
      setPreviousWeekDis(false);
    }
    if (new Date(new Date(props.data.planningDate).toISOString().split('T')[0]) > new Date(new Date(fromDate).toISOString().split('T')[0]) && new Date(new Date(props.data.planningDate).toISOString().split('T')[0]) > new Date(new Date(startDate).toISOString().split('T')[0])) {

      
      setPreviousData(false);
      getHistoryPlanningOverview(salesOrg.toString(), props.data.selectedDeliveryPlant, fromDate,props.data.planMode).then(
        (v: any) => {
          setState({
            isLoaded: true,
            data: v
          });
          props.isLoading(false);
        props.reloadHeaderStatus();
        }).finally(()=>props.isLoading(false));
    } else{
      setPreviousData(true);
      getPlanningOverview(salesOrg.toString(), props.data.selectedDeliveryPlant, fromDate,props.data.planMode).then(
        (v: any) => {
          setState({
            isLoaded: true,
            data: v
          });
          props.isLoading(false);
        props.reloadHeaderStatus();
        }).finally(()=>props.isLoading(false));
    }

  };
  return (
    <>
     {is_disabled?<div className="session-error">{props.session.message} <button onClick={()=> props.setRefresh(true)}> Refresh</button></div>:null}
    
      <Container maxWidth={false} className={classes.container}>
        
  
      
      {
        props.data.selectedDeliveryPlant !== "" ? state.data.data ?(
        <div>
    <Grid container spacing={2} columns={16}>
    <Grid item justifyContent="flex-start" xs={8}>
    
    <Chip
            label={title}
            className={classes.chipActual}
            color="primary"
          />
     </Grid>
    <Grid item justifyContent="flex-end" xs={8}>
    <Grid container justifyContent="flex-end">
    {(checkedRoutes.size>0) && (new Date(props.data.planningDate)>=new Date(new Date().toISOString().split('T')[0])) && (
    <>
       <Button disabled={isDisplayOnlyRole || is_disabled} className={classes.submit} variant="outlined" color="primary" style={{marginLeft:"300px"}} onClick={releaseRoutesHandler} >
            Release Routes
      </Button>
      </>
    )
      }
      {checkedRoutes.size>0 && (
      <>
      <Button disabled={is_disabled}  className={classes.submit} variant="outlined" color="primary" onClick={handlePdfGenerate}>
            Download Route Card
      </Button>
      </>
      )
    }
    {(checkedRoutes.size>0) &&(new Date(props.data.planningDate)>=new Date(new Date().toISOString().split('T')[0])) && (
      <>
      <Button disabled={is_disabled}  className={classes.submit} variant="outlined" color="primary" onClick={handleLoadReportGenerate}>
            Download Load Report
      </Button>
     
      </>
      )
        }

        </Grid>
  
      </Grid>

    </Grid>


    <Box sx={{position:"relative"}} className={classes.outerbox}>
            
    {previousWeekDis==true?<div className={classes.outerLeft} onClick={handlePreviousRelease} ><KeyboardArrowLeft  fontSize="large" className={classes.ArrowLeft} />
                  </div>: <></>
                  }  
                  {futureWeekDis==true?<div className={classes.outerRight}  onClick={handleFutureRelease}><KeyboardArrowRight fontSize="large"  className={classes.ArrowRight}/> </div>
                  : <></>
                  }
              
     
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="right">Route</TableCell>
                    {
                      dateRange.map((item:string, index:number) => {
                        return (
                          <TableCell align="right">{item}
                          { props.autoSaveState&&props.autoSaveState.planningDateStr&&item=== new Date( props.autoSaveState.planningDateStr).toISOString().split('T')[0]?(
                          <Checkbox checked = {checkedRoutes.size===props.data.filteredRoutes.length} onChange={handleAllCheckChange} />):<></>}</TableCell> 
                        );
                      })
                    }           
                  </TableRow>
                </TableHead>
         
                <TableBody>
                  {
                    props.data.filteredRoutes.map((route: any, rindex: number) => {
                      return (
                        <TableRow key={rindex}>
                        <TableCell align="right">{route.route}</TableCell>
                      {
                      dateRange.map((dateStr:string, dindex:number) => {
                        const identifier = dateStr + ";" + route.route;
                        const cnt = state.data.data[identifier];
                        var proposed = 0;
                        var scheduled = 0;
                        var confirmed = 0;
                        var proposedCS = 0;
                        var scheduledCS = 0;
                        var confirmedCS = 0;
                        let isActiveCell  : any;
                        if (cnt) {
                          proposed = cnt.proposed || 0;
                          scheduled = cnt.scheduled || 0;
                          confirmed = cnt.confirmed || 0;
                          proposedCS = cnt.proposedCS || 0;
                          scheduledCS = cnt.scheduledCS || 0;
                          confirmedCS = cnt.confirmedCS || 0;

                          if (cnt.dyRouteAvl)
                          isActiveCell  = true;
                          else 
                          isActiveCell  = false;
                        }
                        if(props.autoSaveState&& new Date( props.autoSaveState.planningDateStr).toISOString().split('T')[0]===dateStr&&props.autoSaveState.route&&props.autoSaveState.route===route.route){
                          scheduledCS=props.autoSaveState&&props.autoSaveState.cases?props.autoSaveState.cases:0;
                          scheduled=props.autoSaveState&&props.autoSaveState.scheduled?props.autoSaveState.scheduled:0;
                          proposed = props.data.overdue || 0;
                          return (
                            <TableCell align="right" key={dindex}><Tooltip title="Overdue(60+ Days) / Scheduled Machines (Scheduled Stops) / Confirmed " followCursor={true} ><span className={isActiveCell  ? classes.dyActiveCell : classes.activeCell}><b>{proposed}</b> ({proposedCS}) / <b>{confirmed===0?scheduled:0}</b> ({confirmed===0?scheduledCS:0}) / <b>{confirmed}</b> ({confirmedCS})</span></Tooltip>
                        
                          
                           {props.autoSaveState&&props.autoSaveState.planningDateStr&&dateStr=== new Date( props.autoSaveState.planningDateStr).toISOString().split('T')[0]?(
                            <Checkbox checked = {checkedRoutes.has(route.route)} onChange={handleCheckChange(route.route)} />):<></>}
                            </TableCell> 
                          );
                        }
                        return (
                          <TableCell align="right" key={dindex}><Tooltip title="Overdue(60+ Days) / Scheduled Machines (Scheduled Stops) / Confirmed " followCursor={true} ><span className={isActiveCell  ? classes.dyActiveCell : ''}><b>{proposed}</b> ({proposedCS}) / <b>{confirmed===0?scheduled:0}</b> ({confirmed===0?scheduledCS:0}) / <b>{confirmed}</b> ({confirmedCS})</span></Tooltip>
                          <span hidden>{setTimeout(()=>{}, 100)}</span>
                          {props.autoSaveState&&props.autoSaveState.planningDateStr&&dateStr=== new Date( props.autoSaveState.planningDateStr).toISOString().split('T')[0]?(
                            <Checkbox checked = {checkedRoutes.has(route.route)} onChange={handleCheckChange(route.route)} />):<></>} 
                          </TableCell>
                        );
                      })
                    }                                                 
                      </TableRow>
                      );
                    })
                  }
                </TableBody>
              </Table>
            </TableContainer>
            </Box>
          </div>):(<div style={{ textAlign: "center"}} ><CircularProgress color="primary" /></div>)
          : <h3 style={{marginTop: '80px', textAlign: 'center'}}>Please select delivery plant and route.</h3>
        }
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={Object.keys(releaseRoutesAlert).length !== 0}
        onClose={() => {
          setReleaseRoutesAlert({});
        }}
      >
        <DialogContent>
          <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={releasebackdropLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
          <Alert severity="error">
            <AlertTitle>{releaseRoutesAlert && releaseRoutesAlert.title ? releaseRoutesAlert.title : `Confirm Release Routes- Delivery Plant: ${props?.data?.selectedDeliveryPlant}`}</AlertTitle>
            <Typography paragraph>{releaseRoutesAlert && releaseRoutesAlert.msg ? releaseRoutesAlert.msg : ""}</Typography>
          </Alert>
      
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
              setReleaseRoutesAlert({});
            }} 
            color="primary">
            No
          </Button>
          <Button disabled={releaseBtndisabled} onClick={releaseRoutesSubmit}  
            color="primary" autoFocus>
            Yes, proceed
          </Button>
        </DialogActions>
      </Dialog>
      

      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={Object.keys(releaseLoadReportAlert).length !== 0}
        onClose={() => {
          setReleaseLoadReportAlert({});
        }}
      >
        <DialogContent>
          <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={releasebackdropLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
          <Alert severity="error">
            <AlertTitle>{releaseLoadReportAlert && releaseLoadReportAlert.title ? releaseLoadReportAlert.title :  `Confirm Release Routes- Delivery Plant: ${props?.data?.selectedDeliveryPlant}`}</AlertTitle>
            <Typography paragraph>{releaseLoadReportAlert && releaseLoadReportAlert.msg ? releaseLoadReportAlert.msg : ""}</Typography>
          </Alert>
          { sheduledList.length>0?
            <>
              <DialogContentText id="alert-dialog-description">
              Customer  are found scheduled from another session. Please review the schedule from planning board to proceed with release.
              </DialogContentText>
              <div>
                <List  style={{
                  "maxHeight": "213px",
                  "display": "block",
                  "overflowY": "scroll"
                  }}>
                  {sheduledList.map((item:any,index)=>{
                    return(
                    <ListItem  key={index}>
                    <div> {item.customer_num}</div>-
                    <div> {item.name1} ,{item.name3}</div>
                    </ListItem>
                    )
                  })}
                </List>
              </div>
            </> :''
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
              setReleaseLoadReportAlert({});
            }} 
            color="primary">
            No
          </Button>
          <Button disabled={releaseBtndisabled} onClick={releaseLoadReport}  
            color="primary" autoFocus>
            Yes, proceed
          </Button>
        </DialogActions>
      </Dialog>



      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorMessage !== undefined}
        onClose={() => {
          setErrorMessage(undefined);
          props.change();
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>Releasing Route Completed</AlertTitle>
            <Typography paragraph>{errorMessage}</Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorMessage(undefined);
              props.change();
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={pdfAlert.showRouteCardAlert}
        onClose={() => {
          setPdfAlert({...pdfAlert,showRouteCardAlert:false});
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>Route Card Alert</AlertTitle>
            <Typography paragraph>{pdfAlert.routeCardAlertMessage}</Typography>
          </Alert>
          { sheduledList.length>0?
            <>
              <DialogContentText id="alert-dialog-description">
              Customer  are found scheduled from another session. Please review the schedule from planning board to proceed with release.
              </DialogContentText>
              <div>
                <List  style={{
                  "maxHeight": "213px",
                  "display": "block",
                  "overflowY": "scroll"
                  }}>
                  {sheduledList.map((item:any,index)=>{
                    return(
                    <ListItem  key={index}>
                    <div> {item.customer_num}</div>-
                    <div> {item.name1} ,{item.name3}</div>
                    </ListItem>
                    )
                  })}
                </List>
              </div>
            </> :''
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
              setPdfAlert({...pdfAlert,showRouteCardAlert:false});
            }} 
            color="primary">
            No
          </Button>
          <Button disabled={pdfAlert.isDownloadRouteCardPdf===false} onClick={()=>{downloadPdf()}}  
            color="primary" autoFocus>
            Yes, proceed
          </Button>
        </DialogActions>
      </Dialog>
       <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
  
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorRouteMessage.validate === false}
        onClose={() => {
          setErrorRouteMessage({ "validate": true,
          "message":[]});
          props.change();
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>Releasing Route Errors</AlertTitle>
            {errorRouteMessage.message.map((res:any)=>{
              return(
                <Typography paragraph>{res.message}</Typography>
              )
            })}
          

          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorRouteMessage({ 
              validate: true,
              message:[]});
              props.change();
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      </Container>
      </>
  );
}
